import { styled, Typography } from "@mui/material";

export const StyledTutorialsContainer = {
  Root: styled("div")({
    width: "100%",
    fontSize: "large",
    fontFamily: "Roboto, sans-serif",
    letterSpacing: "0.0075em",
    color: "#484848",
    marginLeft: 5,
  }),

  SectionTitle: styled("div")({
    fontWeight: 500,
    marginBottom: 10,
    marginTop: 40,
  }),

  Title: styled(Typography)({
    fontWeight: 500,
    marginBottom: 0,
    marginTop: 0,
  }),

  Subtitle: styled(Typography)({
    marginTop: 3,
  }),

  SectionTitleText: styled("p")({
    fontWeight: 500,
    marginBottom: 10,
    marginTop: 40,
  }),
};
